import PrivateRoute from "../PrivateRoute";
import { useState } from "react";
import { useApp } from "../../hooks/AppProvider";

function Logout() {
    let app = useApp();

    let [statusMessage, setStatusMessage] = useState("");

    function logoutClick() {
        app.sendGet("/auth/logout", data => {
            if(!data.success)
                return setStatusMessage("Une erreur c'est produite");
            app.logout();
            app.navigate("/", {replace: true});
            
        });
    }
    
    return (
        <div className="login-container">
            <img src="/img/profile.png" alt="Icone de profile" className="login-profile" />
            <div className="login-message">
                <h2>Déconnexion</h2>
                <span className="error-text">{statusMessage}</span>
                <span>{app.tokenPayload().display_name}: êtes-vous sûr de vouloir vous déconnecter ?</span>
            </div>
            <div className="login-form">
                <button onClick={logoutClick}>Se déconnecter</button>
            </div>
        </div> 
    )
}

export default Logout;